/**
 * Convenience function that generates an options-object to pass to
 * styled components to prevent certain props from being passed-through
 * to the decorated component.
 */
export default function blockForwardingProps(...propNames: string[]) {
  return { shouldForwardProp: (key: string) => !propNames.includes(key) };
}
